export const navLinks = [
  { label: "下载安装", href: "#install" },
  { label: "安卓版", href: "#android" },
  { label: "苹果版", href: "#ios" },
  { label: "最新版", href: "#versions" },
  { label: "社区亮点", href: "#community" },
  { label: "常见问题", href: "#faq" },
  { label: "设备要求", href: "#requirements" },
];

export const heroCards = [
  {
    id: "android",
    tag: "APK",
    title: "安卓版安装包",
    desc: "适配主流安卓机型，含未知来源权限开启与逐屏安装说明。",
    icon: "ri-android-line",
    href: "#android",
  },
  {
    id: "ios",
    tag: "iOS",
    title: "苹果版安装包",
    desc: "iPhone / iPad 安装引导，含描述文件下载与开发者信任设置。",
    icon: "ri-apple-line",
    href: "#ios",
  },
  {
    id: "versions",
    tag: "更新",
    title: "最新版更新说明",
    desc: "对照版本号、更新日期、安装包体积与本次新增功能亮点。",
    icon: "ri-refresh-line",
    href: "#versions",
  },
  {
    id: "faq",
    tag: "答疑",
    title: "常见安装问题",
    desc: "解析包错误、闪退、无法联网等高频问题逐条给出排查思路。",
    icon: "ri-question-line",
    href: "#faq",
  },
];

export const quickSteps = [
  {
    step: "01",
    title: "获取对应安装包",
    desc: "先在下方确认手机系统与版本，再选择安卓版或苹果版入口下载，避免装错版本导致无法运行。",
    icon: "ri-download-2-line",
  },
  {
    step: "02",
    title: "完成安装授权",
    desc: "安卓需在系统设置中允许本次安装；苹果需在「VPN 与设备管理」中信任对应描述文件。",
    icon: "ri-shield-check-line",
  },
  {
    step: "03",
    title: "登录进入视频社区",
    desc: "安装成功后注册或登录账号，选择兴趣标签，即可开始浏览、互动与发布自己的视频。",
    icon: "ri-user-follow-line",
  },
];

export const communityFeatures = [
  {
    title: "兴趣标签视频流",
    icon: "ri-film-line",
    desc: "按兴趣标签浏览短视频、长视频与直播内容，系统会依据观看偏好持续调整推荐。",
  },
  {
    title: "弹幕与评论互动",
    icon: "ri-chat-3-line",
    desc: "边看边发弹幕、评论与点赞，和同好一起追更热门内容，追剧氛围拉满。",
  },
  {
    title: "本地缓存与画中画",
    icon: "ri-movie-line",
    desc: "支持本地缓存离线观看与画中画小窗播放，通勤、出差路上也能接着看。",
  },
  {
    title: "创作与发布",
    icon: "ri-upload-cloud-2-line",
    desc: "手机端即可完成剪辑与发布，参与话题挑战可让作品获得更多曝光机会。",
  },
];

export const reasons = [
  {
    title: "安装说明按系统拆分",
    desc: "安卓与苹果的权限、信任设置差异较大，说明按系统独立成节，照做即可，不用来回猜测。",
    icon: "ri-layout-grid-line",
  },
  {
    title: "常见问题集中排查",
    desc: "把安装失败、闪退、联网异常等高频问题集中整理，遇到提示可先对照排查再决定是否重装。",
    icon: "ri-search-eye-line",
  },
  {
    title: "版本更新一目了然",
    desc: "每个版本的更新日期与功能亮点单独列出，方便判断是否需要升级到最新版。",
    icon: "ri-history-line",
  },
];

export const safetyTips = [
  {
    title: "认准官方入口",
    desc: "仅从本页提供的官方入口或正规应用市场获取安装包，避免第三方来源带来的捆绑与篡改风险。",
  },
  {
    title: "核对文件信息",
    desc: "下载前留意安装包体积与版本号，与页面公布的信息一致再安装，避免装到过期或被修改的文件。",
  },
  {
    title: "谨慎授予权限",
    desc: "仅开放运行必需的网络与存储权限，遇到索要通讯录、短信等与视频功能无关的权限应多加留意。",
  },
  {
    title: "保留卸载方式",
    desc: "提前了解对应系统的卸载路径，安装后若出现异常可及时清理残留并重新安装。",
  },
];

export const requirements = [
  { item: "安卓系统", value: "Android 8.0 及以上", note: "低于该版本可能无法安装或运行不稳定" },
  { item: "苹果系统", value: "iOS 13.0 及以上", note: "iPad 需 iPadOS 13 及以上" },
  { item: "存储空间", value: "预留 500 MB 以上", note: "含安装包体积与首次运行缓存空间" },
  { item: "运行内存", value: "2 GB 及以上", note: "保障高清视频播放与多任务切换流畅" },
  { item: "网络环境", value: "Wi-Fi 或 4G / 5G", note: "建议使用 Wi-Fi 下载安装包，节省流量" },
];

export const reviews = [
  {
    name: "小北",
    role: "安卓用户 · 使用 1 年",
    text: "安装步骤写得很清楚，照着开启未知来源权限，一次就装好了，没再反复失败。",
    rating: 5,
  },
  {
    name: "阿橘",
    role: "iPhone 用户 · 新安装",
    text: "之前一直卡在苹果要信任描述文件那一步，对照这里的说明就顺利打开了。",
    rating: 5,
  },
  {
    name: "林间",
    role: "内容创作者",
    text: "缓存和画中画挺实用，通勤路上能接着看，更新说明也让我知道该不该升级。",
    rating: 4,
  },
  {
    name: "沐沐",
    role: "新用户",
    text: "设备要求那一栏很有用，先对照系统版本再下载，省得白下半天装不上。",
    rating: 5,
  },
];